// extracted by mini-css-extract-plugin
export var fadeInOut = "VideoPanel-module--fadeInOut--1YoGt";
export var mainImage = "VideoPanel-module--mainImage--MPWhc";
export var page404Title = "VideoPanel-module--page404-title--VpDZF";
export var playerWrapper = "VideoPanel-module--playerWrapper--9ed5j";
export var videoButton = "VideoPanel-module--videoButton--PDf9s";
export var videoLaunch = "VideoPanel-module--videoLaunch--gdGn8";
export var videoPictureWrap = "VideoPanel-module--videoPictureWrap--tJuRc";
export var videoPlayer = "VideoPanel-module--videoPlayer--KiGCx";
export var videoWrap = "VideoPanel-module--videoWrap--H3Xne";